import styled, { keyframes } from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Container = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const OuterCircle = styled.div`
	position: relative;
	height: 448px;
	max-height: 100%;
	max-width: 100%;
	display: flex;
	justify-content: center;
	width: 448px;
`;

export const OuterRing = styled.div`
	height: 100%;
	width: 100%;
	position: absolute;
`;

export const Bubble = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;

const breathWords = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const BubbleCopy = styled.h3`
	${fontWeight(FontWeights.Medium)};
	color: ${palette('black')};
	font-size: 24px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	animation: ${breathWords} 5.5s ease-in-out;

	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const ProgressMarker = styled.div`
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
`;

export const BreatheCount = styled.div`
	font-size: 22px;
	margin-top: 40px;
	max-width: 300px;
	min-height: 40px;
	padding-left: 15px;
`;

export const FinishedButton = styled(Button)`
	${fontWeight(FontWeights.Regular)};
	max-width: 66px;
	max-height: 44px;
	font-size: 14px;
	background: rgba(0, 0, 0, 0.2);
	position: absolute;
	right: 15px;
	top: 15px;
	z-index: 10;
`;
